declare namespace $ {

	type $shm_listener__shm_hitalama_quick_1 = $mol_type_enforce<
		[ string, ReturnType< $shm_hitalama_quick['keydown_handler'] > ]
		,
		ConstructorParameters< typeof $shm_listener >
	>
	type __shm_hitalama_quick_2 = $mol_type_enforce<
		Parameters< $shm_hitalama_quick['dragged'] >[0]
		,
		Parameters< $shm_hitalama_quick['Drag'] >[0]
	>
	type $mol_view__sub_shm_hitalama_quick_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_check__checked_shm_hitalama_quick_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_quick['checked'] >
		,
		ReturnType< $mol_check['checked'] >
	>
	type $mol_check__sub_shm_hitalama_quick_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_check['sub'] >
	>
	type $shm_hitalama_quick_item__on_drag_start_shm_hitalama_quick_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_quick['on_drag_start'] >
		,
		ReturnType< $shm_hitalama_quick_item['on_drag_start'] >
	>
	type $shm_hitalama_quick_item__on_drag_end_shm_hitalama_quick_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_quick['on_drag_end'] >
		,
		ReturnType< $shm_hitalama_quick_item['on_drag_end'] >
	>
	type $shm_hitalama_quick_item__y_shm_hitalama_quick_8 = $mol_type_enforce<
		number
		,
		ReturnType< $shm_hitalama_quick_item['y'] >
	>
	type $shm_hitalama_quick_item__left_shm_hitalama_quick_9 = $mol_type_enforce<
		ReturnType< $shm_hitalama_quick['x'] >
		,
		ReturnType< $shm_hitalama_quick_item['left'] >
	>
	type $shm_hitalama_quick_item__sub_shm_hitalama_quick_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_hitalama_quick_item['sub'] >
	>
	type $shm_hitalama_quick_item__event_shm_hitalama_quick_11 = $mol_type_enforce<
		({ 
			pointerenter( next?: ReturnType< $shm_hitalama_quick['pointerenter'] > ): ReturnType< $shm_hitalama_quick['pointerenter'] >,
			pointerleave( next?: ReturnType< $shm_hitalama_quick['pointerleave'] > ): ReturnType< $shm_hitalama_quick['pointerleave'] >,
		}) 
		,
		ReturnType< $shm_hitalama_quick_item['event'] >
	>
	type $mol_view__sub_shm_hitalama_quick_12 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__attr_shm_hitalama_quick_13 = $mol_type_enforce<
		({ 
			'remove_area_active': ReturnType< $shm_hitalama_quick['remove_area_active'] >,
		}) 
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__sub_shm_hitalama_quick_14 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__style_shm_hitalama_quick_15 = $mol_type_enforce<
		({ 
			'width': ReturnType< $shm_hitalama_quick['full_width_px'] >,
		}) 
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_view__sub_shm_hitalama_quick_16 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_hitalama_quick extends $mol_view {
		keydown_handler( ): any
		keydown_listener( ): $shm_listener
		full_width_px( ): string
		on_drag_start( id: any, next?: any ): any
		on_drag_end( id: any, next?: any ): any
		dragged( id: any): ReturnType< ReturnType< $shm_hitalama_quick['Drag'] >['dragged'] >
		x( id: any, next?: number ): number
		checked( id: any, next?: boolean ): boolean
		key( id: any): string
		Speck( id: any): $mol_view
		label( id: any): string
		Button( id: any): $mol_check
		pointerenter( id: any, next?: any ): any
		pointerleave( id: any, next?: any ): any
		Drag( id: any): $shm_hitalama_quick_item
		buttons( ): readonly(any)[]
		Cut_icon( ): $mol_icon_trash_can
		remove_area_active( next?: boolean ): boolean
		Remove_area( ): $mol_view
		remove_area_visible( ): readonly(any)[]
		hovered_title( ): string
		Hovered_title( ): $mol_view
		hovered_title_visible( ): readonly(any)[]
		Panel( ): $mol_view
		item( id: any): $shm_hitalama_quick_item_contract
		drag_start_event( id: any, next?: any ): any
		drag_end_event( id: any, next?: any ): any
		drag_pan( id: any): any
		some_dragged( ): boolean
		hovered_id( next?: string ): string
		auto( ): readonly(any)[]
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=quick.view.tree.d.ts.map